import { buildRoute } from '@direct-frontend/modules-router';

export const storesRoute = buildRoute('/stores');
export const storesNewRoute = buildRoute('/stores/new');
export const storesExternalCheckoutsRoute = buildRoute('/stores/checkouts');
export const storesNewExternalCheckoutRoute = buildRoute('/stores/checkouts/new');
export const storesLiteRoute = buildRoute('/stores/lite'); // Kit Lite
export const storesNewLiteRoute = buildRoute('/stores/lite/new'); // Kit Lite

export const SEARCH_PARAM_DELETE_STORE_SUCCESS = 'deleteStoreSuccess';
